'use client';
import { useI18n } from '@/i18n';
import { LanguageSwitcher } from './LanguageSwitcher';

function FooterSection({
  title,
  links,
}: {
  title: string;
  links: Array<{ label: string; href: string }>;
}) {
  return (
    <div>
      <h4 className="text-sm font-medium text-foreground mb-4">{title}</h4>
      <ul className="space-y-3">
        {links.map((link, i) => (
          <li key={i}>
            <a
              href={link.href}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Footer() {
  const { t } = useI18n();

  return (
    <footer className="border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="col-span-2">
            <a href="/" className="flex items-center gap-2">
              <img
                src="https://deepbuild-v1.s3.ap-south-1.amazonaws.com/uploads/1770892004000-8ahuwvb4q3d-4.png"
                alt={t.footer.logoAlt}
                className="h-40 w-auto object-contain mix-blend-multiply"
                style={{ backgroundColor: 'transparent' }}
              />
            </a>
            <p className="text-sm text-muted-foreground max-w-xs">
              {t.footer.description}
            </p>
          </div>

          <FooterSection title={t.footer.product.title} links={t.footer.product.links} />
          <FooterSection title={t.footer.company.title} links={t.footer.company.links} />
          <FooterSection title={t.footer.support.title} links={t.footer.support.links} />
          <FooterSection title={t.footer.legal.title} links={t.footer.legal.links} />
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">&copy; {t.footer.copyright}</p>
          <div className="flex items-center gap-4">
            <span className="text-sm text-muted-foreground">{t.footer.madeWith}</span>
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </footer>
  );
}
